import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const BatteryChargeTime = withFacetContext(
    FacetName.battery_charge_time_values,
    withFilterContext(FilterName.battery_charge_time_values, SearchFiltersDropdown, {
        title: 'Home charging',
        hideLabel: false,
    })
)
